import React from 'react'
import { useOutlet } from 'react-router-dom'
import ExternalLayout from './components/ExternalLayout'

export default function External() {
  const outlet = useOutlet()

  return <ExternalLayout>{outlet}</ExternalLayout>
}
